"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAlertHandler = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var alerts_1 = require("../../events/alerts");
var alerts_2 = require("../../store/alerts");
function createAlert(ctx, alert) {
    var backend = ctx.backend, workspace = ctx.workspace;
    return backend.workspace(workspace).dashboards().createWidgetAlert(alert);
}
function createAlertHandler(ctx, cmd) {
    var alert;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(createAlert, ctx, cmd.payload.alert)];
            case 1:
                alert = _a.sent();
                return [4 /*yield*/, effects_1.put(alerts_2.alertsActions.addAlert(alert))];
            case 2:
                _a.sent();
                return [2 /*return*/, alerts_1.alertCreated(ctx, alert, cmd.correlationId)];
        }
    });
}
exports.createAlertHandler = createAlertHandler;
//# sourceMappingURL=createAlertHandler.js.map